import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';
import { ReactComponent as Help } from '../../../assets/help.svg';
import useStyles from './LogoutIcon.styles';

const HelpIcon = () => {
  const classes = useStyles();

  return <SvgIcon classes={classes} component={Help} title="Help" fontSize="large" viewBox="0 -960 960 960" />;
};

export default React.memo(HelpIcon);
